<template>
	<div class="transitioner">
		<!-- used during loading -->
		<transition mode="out-in" :css="false" v-on:leave="hideLoader">
			<loader v-if="showLoader && isVisible" ref="loader"></loader>
		</transition>

		<!-- this is used between list and viewer (show category on top of it) -->
		<div class="layer" :class="{'-overlap': overlap}" ref="layer"></div>
		<component v-bind:is="mask" class="svg" v-if="overlap"></component>
	</div>
</template>

<script>
// vuex
import { mapGetters } from 'vuex'

// icons
import Australia from '@/assets/categories/australia.svg'
import NewZealand from '@/assets/categories/new-zealand.svg'
import CookIslands from '@/assets/categories/cook-islands.svg'
import NewCaledonia from '@/assets/categories/new-caledonia.svg'
import FrenchPolynesia from '@/assets/categories/french-polynesia.svg'
import France from '@/assets/categories/france.svg'
import Norway from '@/assets/categories/norway.svg'
import Iceland from '@/assets/categories/iceland.svg'
import Indonesia from '@/assets/categories/indonesia.svg'

// animation
import anime from 'animejs'

// import components
import Loader from '@/components/Loader'

export default {
	name: 'transitioner',
	components: {
		'loader': Loader,
		'australia': Australia,
		'new-zealand': NewZealand,
		'cook-islands': CookIslands,
		'new-caledonia': NewCaledonia,
		'french-polynesia': FrenchPolynesia,
		'france': France,
		'norway': Norway,
		'iceland': Iceland,
		'indonesia': Indonesia
	},
	data () {
		return {
			isVisible: false,
			showLoader: false
		}
	},
	methods: {
		show (cb) {
			this.cb = cb || null
			this.isVisible = true

			anime({
				targets: this.$refs.layer,
				transformOrigin: ['0% 0%', '0% 0%'],
				scaleX: [0, 1],
				duration: 700,
				easing: 'easeInQuint'
			}).complete = () => {
				if (!this.appFetched) this.showLoader = true
				else this.notify()
			}
		},
		notify () {
			this.showLoader = false

			if (typeof this.cb === 'function') {
				this.$bus.$emit('transitioner:visible')
				this.cb()
				this.hide()
			} else {
				this.hide()
			}
		},
		hide () {
			anime({
				targets: this.$refs.layer,
				transformOrigin: ['100% 0%', '100% 0%'],
				scaleX: [1, 0],
				duration: 500,
				easing: 'easeInQuint'
			}).complete = () => {
				this.notifyEnd()
			}
		},
		notifyEnd () {
			this.isVisible = false
			this.$bus.$emit('section:ready')
		},
		hideLoader () {
			anime({
				targets: this.$refs.loader,
				opacity: [1, 0],
				duration: 450,
				easing: 'easeInOutSine'
			})
		}
	},
	watch: {
		appFetched (newVal, oldVal) {
			if (newVal) this.notify()
		}
	},
	computed: {
		...mapGetters({
			mask: 'mask',
			appFetched: 'fetched'
		}),
		getMaskPath (icon) {
			return `/static/categories/${this.mask}.svg`
		},
		overlap () {
			return (this.$route.name === 'viewer') && this.mask && this.isVisible
		}
	},
	mounted () {
		this.$bus.$on('transitioner:show', this.show)
		this.$bus.$on('transitioner:hide', this.hide)
	}
}
</script>

<style scoped>
	.transitioner{
		position: fixed;
		z-index: 100;
		pointer-events: none;
	}
	.layer{
		transform: scaleX(0);
		position: fixed;
		top: 0;
		background: #F4F4F4;
		height: 100%;
		width: 100%;
		z-index: 10;
	}
	.layer.-overlap{
		z-index: 1;
	}
	.loader{

	}
</style>



// WEBPACK FOOTER //
// src/components/Transitioner.vue